module.exports = __webpack_public_path__ + "img/gabrielle-henderson-Y3OrAn230bs-unsplash.9467336a.jpg";